// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../../../provider/Context.bs.js";
import * as Atom_Row from "../../../atom/Atom_Row.bs.js";
import * as Atom_Cell from "../../../atom/Atom_Cell.bs.js";
import * as Atom_Grid from "../../../atom/Atom_Grid.bs.js";
import * as Atom_Text from "../../../atom/Atom_Text.bs.js";
import * as Atom_Image from "../../../atom/Atom_Image.bs.js";
import * as Atom_Label from "../../../atom/Atom_Label.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Util_Array from "../../../../util/Util_Array.bs.js";
import * as Atom_Column from "../../../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as Type_String from "../../../../type/Type_String.bs.js";
import * as Type_Teaser from "../../../../type/Type_Teaser.bs.js";
import * as Atom_Text_Ds from "../../../atom/Atom_Text_Ds.bs.js";
import * as Particle_Css from "../../../particle/Particle_Css.bs.js";
import * as Particle_Screen_Ds from "../../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../../particle/Particle_Spacer_Ds.bs.js";
import * as UseTrackingAmplitude from "../../../../hook/UseTrackingAmplitude.bs.js";
import * as Molecule_ExpanderText from "../../../molecule/Molecule_ExpanderText.bs.js";
import * as Particle_Animation_Ds from "../../../particle/Particle_Animation_Ds.bs.js";
import * as Template_ProgramContent from "./Template_ProgramContent.bs.js";
import * as Particle_Screen_Constants from "../../../particle/Particle_Screen_Constants.bs.js";

function Template_ProgramContent_Description$Heading(Props) {
  var title = Props.title;
  var subtitle = Props.subtitle;
  if (title !== undefined) {
    if (subtitle !== undefined) {
      return React.createElement(React.Fragment, undefined, React.createElement(Atom_Text.make, {
                      children: null,
                      kind: "h1"
                    }, React.createElement(Atom_Text.make, {
                          children: Curry._1(Type_String.Teaser.Title.toString, title),
                          kind: "span",
                          style: Atom_Text_Ds.ProgramContent.make("Title")
                        }), React.createElement(Atom_Text.make, {
                          children: Curry._1(Type_String.Teaser.Subtitle.toString, subtitle),
                          kind: "span",
                          style: Atom_Text_Ds.ProgramContent.make("Subtitle")
                        })));
    } else {
      return React.createElement(Atom_Text.make, {
                  children: Curry._1(Type_String.Teaser.Title.toString, title),
                  kind: "h1",
                  style: Atom_Text_Ds.ProgramContent.make("Title")
                });
    }
  } else {
    return null;
  }
}

var Heading = {
  make: Template_ProgramContent_Description$Heading
};

var emptyColumns = {
  left: undefined,
  right: undefined
};

function Template_ProgramContent_Description$Credits$Credit(Props) {
  var values = Props.values;
  var label = Props.label;
  var rulesValues = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.alignSelf("flexEnd")]);
  var len = values.length;
  var tmp;
  if (len !== 1) {
    tmp = len !== 0 ? React.createElement(Atom_Column.make, {
            children: Belt_Array.mapWithIndex(values, (function (i, value) {
                    var value$1 = Curry._1(Type_String.Credit.Value.toString, value);
                    return React.createElement(Atom_Cell.make, {
                                kind: /* ItemList */4,
                                children: React.createElement(Template_ProgramContent.Value.make, {
                                      value: value$1,
                                      key: String(i)
                                    }),
                                key: value$1
                              });
                  })),
            kind: /* List */5,
            rules: rulesValues
          }) : null;
  } else {
    var value = values[0];
    tmp = React.createElement(Atom_Column.make, {
          children: React.createElement(Template_ProgramContent.Value.make, {
                value: Curry._1(Type_String.Credit.Value.toString, value)
              }),
          rules: rulesValues
        });
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Template_ProgramContent.Label.make, {
                  label: Curry._1(Type_String.Credit.Value.toString, label)
                }), tmp);
}

var Credit = {
  make: Template_ProgramContent_Description$Credits$Credit
};

function splitCredits(credits) {
  return Belt_Array.reduce(credits, emptyColumns, (function (accumulator, param) {
                var values = param.values;
                var label = param.label;
                var code = param.code;
                if (code === "SCE" || code === "REA" || code === "PRO" || code === "PRD" || code === "MUS" || code === "MON" || code === "IMA") {
                  var left = Util_Array.append(Belt_Option.getWithDefault(accumulator.left, []), React.createElement(Template_ProgramContent_Description$Credits$Credit, {
                            values: values,
                            label: label,
                            key: code
                          }));
                  return {
                          left: left,
                          right: accumulator.right
                        };
                }
                var right = Util_Array.append(Belt_Option.getWithDefault(accumulator.right, []), React.createElement(Template_ProgramContent_Description$Credits$Credit, {
                          values: values,
                          label: label,
                          key: code
                        }));
                return {
                        left: accumulator.left,
                        right: right
                      };
              }));
}

var containerAlignItems = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "start");

var widthForTwoColumns = Css_Js_Core.Calc.$neg(CssJs.pct(50), CssJs.pxFloat(Particle_Css.spacerSizeInsideValue("S") / 2));

var columnWidth = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, widthForTwoColumns, CssJs.pct(100));

var columnGapColumn = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");

var columnRules = Particle_Screen_Ds.make(undefined, [CssJs.gridTemplateColumns([
            CssJs.fr(1),
            CssJs.fr(2)
          ])], undefined, undefined, undefined, [CssJs.gridTemplateColumns([
            CssJs.fr(1),
            CssJs.fr(1)
          ])]);

var Css = {
  containerAlignItems: containerAlignItems,
  marginRightValue: "S",
  widthForTwoColumns: widthForTwoColumns,
  columnWidth: columnWidth,
  columnGapColumn: columnGapColumn,
  columnRules: columnRules
};

function Template_ProgramContent_Description$Credits(Props) {
  var credits = Props.credits;
  var columns = splitCredits(credits);
  var left = columns.left;
  var leftColumn = left !== undefined ? React.createElement(Atom_Grid.make, {
          children: left,
          gapColumn: columnGapColumn,
          rules: columnRules,
          width: columnWidth
        }) : null;
  var right = columns.right;
  var rightColumn = right !== undefined ? React.createElement(Atom_Grid.make, {
          children: right,
          gapColumn: columnGapColumn,
          rules: columnRules,
          width: columnWidth
        }) : null;
  return React.createElement(Atom_Row.make, {
              alignItems: containerAlignItems,
              children: null
            }, leftColumn, rightColumn);
}

var Credits = {
  emptyColumns: emptyColumns,
  Credit: Credit,
  splitCredits: splitCredits,
  Css: Css,
  make: Template_ProgramContent_Description$Credits
};

function Template_ProgramContent_Description$FirstBroadcastSticker(Props) {
  var programKind = Props.programKind;
  var value = Props.value;
  var match = Context.I18n.getState(undefined);
  var match$1 = match.labels.program;
  if (programKind === undefined) {
    return null;
  }
  if (programKind !== "MAGAZINE") {
    return null;
  }
  if (value === undefined) {
    return null;
  }
  var dateLabel = Curry._1(match.formaters.date, new Date(Curry._1(Type_String.Program.FirstBroadcastDate.toString, value)));
  return React.createElement(Atom_Cell.make, {
              blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeTop("L")), undefined, Particle_Spacer_Ds.makeTop("M")),
              children: React.createElement(Atom_Label.make, {
                    text: match$1.showOf + " " + dateLabel,
                    style: Atom_Label.firstBroadcastDate
                  })
            });
}

var FirstBroadcastSticker = {
  make: Template_ProgramContent_Description$FirstBroadcastSticker
};

function Template_ProgramContent_Description$Description(Props) {
  var program = Props.program;
  var credits = Props.credits;
  var firstBroadcastDate = Props.firstBroadcastDate;
  var descriptionBehavior = Props.descriptionBehavior;
  var shortDescription = program.shortDescription;
  var description = program.description;
  var _trackAmplitude = UseTrackingAmplitude.useUserAction("read_more_button");
  return React.createElement(React.Fragment, undefined, React.createElement(Template_ProgramContent_Description$FirstBroadcastSticker, {
                  programKind: program.kind,
                  value: firstBroadcastDate
                }), React.createElement(Molecule_ExpanderText.make, {
                  children: null,
                  innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S"),
                  blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeTop("L")), undefined, Particle_Spacer_Ds.makeTop("M")),
                  textStyle: Atom_Text_Ds.ProgramContent.makeDescBold,
                  behavior: descriptionBehavior,
                  onClick: _trackAmplitude
                }, shortDescription !== undefined ? React.createElement(Atom_Text.DangerouslySetInnerHTML.make, {
                        style: Atom_Text_Ds.ProgramContent.makeDescBold,
                        dangerouslySetInnerHTML: shortDescription
                      }) : null, description !== undefined ? React.createElement(Atom_Text.DangerouslySetInnerHTML.make, {
                        style: Atom_Text_Ds.ProgramContent.make("Desc"),
                        dangerouslySetInnerHTML: description
                      }) : null, credits !== undefined ? React.createElement(Template_ProgramContent_Description$Credits, {
                        credits: credits
                      }) : null));
}

var Description = {
  make: Template_ProgramContent_Description$Description
};

function Template_ProgramContent_Description(Props) {
  var teaser = Props.teaser;
  var descriptionBehavior = Props.descriptionBehavior;
  var ref_ = Props.ref_;
  var program = teaser.program;
  var title = Type_Teaser.Helper.extractTitle(teaser);
  var subtitle = Type_Teaser.Helper.extractSubtitleString(teaser.subtitle);
  var tmp = {
    children: null,
    height: Particle_Screen_Constants.oneHundredPctHeight
  };
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(Atom_Column.make, tmp, React.createElement(Template_ProgramContent_Description$Heading, {
                  title: title,
                  subtitle: subtitle
                }), React.createElement(Template_ProgramContent_Description$Description, {
                  program: program,
                  credits: teaser.credits,
                  firstBroadcastDate: program.firstBroadcastDate,
                  descriptionBehavior: descriptionBehavior
                }));
}

function Template_ProgramContent_Description$Presse$RcBanner(Props) {
  var program = Props.program;
  if (program !== undefined) {
    return React.createElement(Atom_Cell.make, {
                width: Particle_Screen_Constants.oneHundredPctWidth,
                height: Particle_Screen_Constants.oneHundredPctHeight,
                children: React.createElement(Atom_Image.Presse.make, {
                      alt: "",
                      animation: Particle_Animation_Ds.TopTeaserPresse.background,
                      autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                      kind: /* Gradient */1,
                      src: program.imageSrc,
                      style: /* PresseTopTeaser */12
                    }),
                rules: Particle_Screen_Ds.make(undefined, undefined, [CssJs.height("inherit_")], undefined, undefined, [CssJs.height({
                            NAME: "px",
                            VAL: 180
                          })])
              });
  } else {
    return null;
  }
}

var RcBanner = {
  make: Template_ProgramContent_Description$Presse$RcBanner
};

function Template_ProgramContent_Description$Presse$ShortDescription(Props) {
  var program = Props.program;
  var shortDescription = program.shortDescription;
  return React.createElement(React.Fragment, undefined, shortDescription !== undefined ? React.createElement(Atom_Text.DangerouslySetInnerHTML.make, {
                    style: Atom_Text_Ds.ProgramContent.makeValue,
                    dangerouslySetInnerHTML: shortDescription
                  }) : null);
}

var ShortDescription = {
  make: Template_ProgramContent_Description$Presse$ShortDescription
};

function Template_ProgramContent_Description$Presse$Description(Props) {
  var program = Props.program;
  var credits = Props.credits;
  var firstBroadcastDate = Props.firstBroadcastDate;
  var descriptionBehavior = Props.descriptionBehavior;
  var description = program.description;
  var _trackAmplitude = UseTrackingAmplitude.useUserAction("read_more_button");
  return React.createElement(React.Fragment, undefined, React.createElement(Template_ProgramContent_Description$FirstBroadcastSticker, {
                  programKind: program.kind,
                  value: firstBroadcastDate
                }), React.createElement(Molecule_ExpanderText.make, {
                  children: null,
                  innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S"),
                  blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeTop("L")), undefined, Particle_Spacer_Ds.makeTop("M")),
                  textStyle: Atom_Text_Ds.ProgramContent.makeDescBold,
                  behavior: descriptionBehavior,
                  variant: /* PresseRc */1,
                  onClick: _trackAmplitude
                }, description !== undefined ? React.createElement(Atom_Text.DangerouslySetInnerHTML.make, {
                        style: Atom_Text_Ds.ProgramContent.make("Desc"),
                        dangerouslySetInnerHTML: description
                      }) : null, credits !== undefined ? React.createElement(Template_ProgramContent_Description$Credits, {
                        credits: credits
                      }) : null));
}

var Description$1 = {
  make: Template_ProgramContent_Description$Presse$Description
};

function Template_ProgramContent_Description$Presse(Props) {
  var teaser = Props.teaser;
  var descriptionBehavior = Props.descriptionBehavior;
  var ref_ = Props.ref_;
  var headingRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.gridArea({
              NAME: "ident",
              VAL: "title"
            })]);
  var descriptionRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.gridArea({
              NAME: "ident",
              VAL: "description"
            })]);
  var program = teaser.program;
  var title = Type_Teaser.Helper.extractTitle(teaser);
  var subtitle = Type_Teaser.Helper.extractSubtitleString(teaser.subtitle);
  var titleBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("M"));
  var shortDescriptionBlockSpace = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeRight("XL")), undefined, undefined, Particle_Spacer_Ds.makeRight("Zero"));
  var tmp = {
    children: null,
    rules: headingRules
  };
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Column.make, tmp, React.createElement(Atom_Row.make, {
                      blockSpace: titleBlockSpace,
                      children: React.createElement(Template_ProgramContent_Description$Heading, {
                            title: title,
                            subtitle: subtitle
                          })
                    }), React.createElement(Atom_Row.make, {
                      blockSpace: shortDescriptionBlockSpace,
                      children: React.createElement(Template_ProgramContent_Description$Presse$ShortDescription, {
                            program: program
                          })
                    })), React.createElement(Atom_Column.make, {
                  children: React.createElement(Template_ProgramContent_Description$Presse$Description, {
                        program: program,
                        credits: teaser.credits,
                        firstBroadcastDate: program.firstBroadcastDate,
                        descriptionBehavior: descriptionBehavior
                      }),
                  rules: descriptionRules
                }));
}

var Presse = {
  RcBanner: RcBanner,
  ShortDescription: ShortDescription,
  Description: Description$1,
  make: Template_ProgramContent_Description$Presse
};

Template_ProgramContent_Description.displayName = "Template_ProgramContent_Description";

var make = Template_ProgramContent_Description;

export {
  Heading ,
  Credits ,
  FirstBroadcastSticker ,
  Description ,
  make ,
  Presse ,
}
/* containerAlignItems Not a pure module */
